
























































































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';

import { MODAL_NAMES } from '~/components/common/SimpleModal/constants';
import SvgImage from '~/components/General/SvgImage.vue';
import {
  CategoryTree, ProductInterface, useTax, useUiState,
} from '~/composables';
import { APP_ROUTER_PATHS } from '~/constants';
import { getProductPath, isGenuine } from '~/helpers/productHelpers';

export default defineComponent({
  name: 'CategoryHeader',
  components: {
    SvgImage,
  },
  props: {
    category: {
      type: Object as () => CategoryTree,
      required: true,
    },
  },
  setup(props) {
    const { toggleModal } = useUiState();
    const { vatLabel, rawPriceCalculation, getCalculatedPrice } = useTax();
    const isImageExist = ref<boolean>(!!props.category.image);

    const isCompatibleProducts = computed(() => !!props.category?.products?.items?.find((product) => !isGenuine(product)));
    const brandTitle = computed(() => {
      const parentCategoryName = props.category.breadcrumbs?.[1]?.category_name;

      return `${parentCategoryName || ''} ${props.category.name || ''}`;
    });
    const categoryTitle = computed(() => {
      const mainCategoryName = props.category.breadcrumbs?.[0]?.category_name;

      return `${brandTitle.value} ${mainCategoryName || ''}`;
    });

    const showCategoryImagePopup = () => toggleModal({
      identifier: MODAL_NAMES.lightboxImage,
      props: {
        image: {
          src: props.category.image,
          alt: categoryTitle.value,
        },
      },
    });

    const printerAsProduct = computed(() => {
      const product: ProductInterface = props.category.printer_as_product;

      if (!product) {
        return {};
      }

      return {
        price: getCalculatedPrice(product.price.minimalPrice),
        isInStock: product.stock?.is_in_stock && product.stock?.qty > 0,
        url: getProductPath(product),
      };
    });

    return {
      categoryTitle,
      brandTitle,
      vatLabel,
      printerAsProduct,
      isImageExist,
      isCompatibleProducts,
      switchSavePath: APP_ROUTER_PATHS.switchSave,
      showCategoryImagePopup,
      rawPriceCalculation,
    };
  },
});
